<template>
<el-dialog :visible="!!detail" title="查看详情" width="1000px" @close="closeDialog">
   <el-form v-if="detail" :model="info" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="区间值：" prop="sectionNum">
        <el-input v-model="info.sectionNum" type="number"></el-input>
      </el-form-item>
      <el-form-item label="系数：" prop="coefficient">
        <el-input v-model="info.coefficient" type="number"></el-input>
      </el-form-item>
    </el-form>
  <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
</el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  name: 'pledgeDetail',
  data() {
    return {
      info: {},
      rules: {
        sectionNum: {
          required: true,
          message: '请填写'
        },
        coefficient: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('pledgeCoefficient', ['detail'])
  },
  watch: {
    detail(val) {
      this.info = val && Object.assign({}, val);
    }
  },
  methods: {
    ...mapMutations('pledgeCoefficient', ['setDetail']),
    ...mapActions('pledgeCoefficient', ['update']),
    closeDialog() {
      this.setDetail(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.update(this.info).then(() => {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.closeDialog();
            this.$emit('refresh', {
              page: 1
            });
          });
        }
      });
    }
  }
};
</script>
